import { useQuery } from '@tanstack/react-query';

import { MembershipType } from 'src/features/membershipType/types';
import axios from 'src/lib/axios';
import { ListResponseSmartParkAPI } from 'src/lib/queries';
import { QueryConfig } from 'src/lib/react-query';
import { ListDTO } from 'src/registry/types/queries';
import { formatResourcePath } from 'src/utils/regex';

const RESOURCE = `sp-core/:parkingId/memberships/membership-type/`;

type QueryFnType = typeof queryFn;

interface DTO extends ListDTO {
    parkingId: string;
    category?: string;
    is_active?: boolean;
}

const queryFn = ({ parkingId, ...params }: DTO): Promise<ListResponseSmartParkAPI<MembershipType>> => {
    return axios.get(formatResourcePath(RESOURCE, { parkingId }), { params });
};

interface UseQueryHookOptions extends DTO {
    config?: QueryConfig<QueryFnType>;
}
const useQueryHook = ({ config, ...payload }: UseQueryHookOptions) =>
    useQuery({
        queryKey: [RESOURCE, payload],
        queryFn: async () => await queryFn(payload),
        ...config,
        staleTime: 1000 * 60 * 5,
    });

export { RESOURCE as LIST_MEMBERSHIP_TYPES_RESOURCE, useQueryHook as useListMembershipTypes };
